import toolsClient from "@/api/toolsClient";

const list = async (type = null, id = null) => {
  const url = type && id ? `${type}/${id}` : `portal`;

  const { data } = await toolsClient.get(`${url}/people`);

  return data;
};

export const removeRole = async (user, role, type = null, id = null) => {
  let userId = null;

  if (user.id) {
    userId = user.id;
  } else if (user.email) {
    userId = `?email=${encodeURIComponent(user.email)}`;
  }

  if (!userId) {
    throw new Error("User id or email is required");
  }

  const url = type && id ? `${type}/${id}` : `portal`;

  await toolsClient.delete(`${url}/people/${role}/${userId}`);
};

export const sendInvite = async (
  email,
  role,
  type = null,
  identifier = null
) => {
  const url = type && identifier ? `${type}/${identifier}` : `portal`;

  await toolsClient.post(`${url}/people/${role}?email=${encodeURIComponent(email)}`);
};

export const getInvited = async (type, identifier) => {
  const { data } = await toolsClient.get(`${type}/${identifier}/invites`);

  return data;
};

const cancelInvite = async (token, type, identifier) => {
  await toolsClient.delete(`${type}/${identifier}/invites/${token}`);
};

export const listAccountAccess = async (accountKey) => {
  const { data } = await toolsClient.get(`accounts/${accountKey}/people/access`);

  return data;
};

export const inviteAccountAccess = async (accountKey, email, assignments) => {
  const { data } = await toolsClient.post(`accounts/${accountKey}/people/invites`, {
    email,
    assignments,
  });

  return data;
};

export const updateAccountAccess = async (accountKey, person, assignments) => {
  const resource = person.inviteToken
    ? `invites/${person.inviteToken}/access`
    : `people/${person.id}/access`;
  const { data } = await toolsClient.put(`accounts/${accountKey}/${resource}`, {
    assignments,
  });

  return data;
};

export const revokeAccountAccess = async (accountKey, person) => {
  if (person.inviteToken) {
    await cancelInvite(person.inviteToken, "accounts", accountKey);
    return;
  }

  await toolsClient.delete(`accounts/${accountKey}/people/${person.id}/access`);
};

export default {
  list,
  removeRole,
  getInvited,
  sendInvite,
  listAccountAccess,
  inviteAccountAccess,
  updateAccountAccess,
  revokeAccountAccess,
};
